import { AuthError } from "../components/Auth/client";

/**
 * Validates if a string is a valid email address
 * @param email - The email string to validate
 * @returns True if the email is valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Gets the appropriate error message for authentication errors
 * @param hasEmailError - Whether there's an email validation error
 * @param error - The authentication error type
 * @returns The error message string
 */
export const getAuthErrorMessage = (
  hasEmailError: boolean,
  error: AuthError | null,
): string => {
  if (hasEmailError) {
    return "Please enter a valid email address.";
  }

  if (error === AuthError.INVALID_CREDENTIALS) {
    return "Invalid email or password.";
  }

  if (error === AuthError.PASSWORD_ATTEMPTS_EXCEEDED) {
    return "Too many failed login attempts. Please try again later or contact support.";
  }

  if (error === AuthError.NETWORK_ERROR) {
    return "Server temporarily unavailable. Please try again later.";
  }

  return "";
};
